// Recovered compiled webpack factory 12583. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { BX: () => R, vK: () => D, lr: () => C });
  var n = i(27290),
    s = i(23863),
    r = i(15075),
    o = i(8453),
    a = i(63946),
    l = i(82617),
    h = i(87913),
    u = i(38358),
    d = i(27424),
    c = i(39622),
    p = i(22039),
    m = i(24888),
    f = i(82264),
    v = i(55389),
    y = i(20091),
    g = i(12205);
  let x = [...y.T, v.y, m.f];
  var w = i(33182),
    T = i(36851),
    b = i(28033),
    S = i(40479),
    P = i(15824),
    A = i(10883),
    E = i(40031),
    M = i(73934);
  let k = [
      "AnimationStart",
      "AnimationComplete",
      "Update",
      "BeforeLayoutMeasure",
      "LayoutMeasure",
      "LayoutAnimationStart",
      "LayoutAnimationComplete",
    ],
    V = {};
  function C(t) {
    V = t;
  }
  function D() {
    return V;
  }
  class R {
    scrapeMotionValuesFromProps(t, e, i) {
      return {};
    }
    constructor(
      {
        parent: t,
        props: e,
        presenceContext: i,
        reducedMotionConfig: n,
        skipAnimations: s,
        blockInitialAnimation: r,
        visualState: o,
      },
      l = {},
    ) {
      ((this.current = null),
        (this.children = new Set()),
        (this.isVariantNode = !1),
        (this.isControllingVariants = !1),
        (this.shouldReduceMotion = null),
        (this.shouldSkipAnimations = !1),
        (this.values = new Map()),
        (this.KeyframeResolver = a.h),
        (this.features = {}),
        (this.valueSubscriptions = new Map()),
        (this.prevMotionValues = {}),
        (this.hasBeenMounted = !1),
        (this.events = {}),
        (this.propEventSubscriptions = {}),
        (this.notifyUpdate = () => this.notify("Update", this.latestValues)),
        (this.render = () => {
          this.current &&
            (this.triggerBuild(),
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
        }),
        (this.renderScheduledAt = 0),
        (this.scheduleRender = () => {
          let t = d.k.now();
          this.renderScheduledAt < t &&
            ((this.renderScheduledAt = t), M.Gt.render(this.render, !1, !0));
        }));
      let { latestValues: h, renderState: u } = o;
      ((this.latestValues = h),
        (this.baseTarget = { ...h }),
        (this.initialValues = e.initial ? { ...h } : {}),
        (this.renderState = u),
        (this.parent = t),
        (this.props = e),
        (this.presenceContext = i),
        (this.depth = t ? t.depth + 1 : 0),
        (this.reducedMotionConfig = n),
        (this.skipAnimationsConfig = s),
        (this.options = l),
        (this.blockInitialAnimation = !!r),
        (this.isControllingVariants = (0, b.e)(e)),
        (this.isVariantNode = (0, b.O)(e)),
        this.isVariantNode && (this.variantChildren = new Set()),
        (this.manuallyAnimateOnMount = !!(t && t.current)));
      let { willChange: c, ...p } = this.scrapeMotionValuesFromProps(e, {}, this);
      for (let t in p) {
        let e = p[t];
        void 0 !== h[t] && (0, w.S)(e) && e.set(h[t]);
      }
    }
    mount(t) {
      if (this.hasBeenMounted)
        for (let t in this.initialValues)
          (this.values.get(t)?.jump(this.initialValues[t]),
            (this.latestValues[t] = this.initialValues[t]));
      ((this.current = t),
        T.C.set(t, this),
        this.projection && !this.projection.instance && this.projection.mount(t),
        this.parent &&
          this.isVariantNode &&
          !this.isControllingVariants &&
          (this.removeFromVariantTree = this.parent.addVariantChild(this)),
        this.values.forEach((t, e) => this.bindToMotionValue(e, t)),
        "never" === this.reducedMotionConfig
          ? (this.shouldReduceMotion = !1)
          : "always" === this.reducedMotionConfig
            ? (this.shouldReduceMotion = !0)
            : (E.r.current || (0, P.Uu)(), (this.shouldReduceMotion = E.O.current)),
        (this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1),
        this.parent?.addChild(this),
        this.update(this.props, this.presenceContext),
        (this.hasBeenMounted = !0));
    }
    unmount() {
      for (let t in (this.projection && this.projection.unmount(),
      (0, M.WG)(this.notifyUpdate),
      (0, M.WG)(this.render),
      this.valueSubscriptions.forEach((t) => t()),
      this.valueSubscriptions.clear(),
      this.removeFromVariantTree && this.removeFromVariantTree(),
      this.parent?.removeChild(this),
      this.events))
        this.events[t].clear();
      for (let t in this.features) {
        let e = this.features[t];
        e && (e.unmount(), (e.isMounted = !1));
      }
      this.current = null;
    }
    addChild(t) {
      (this.children.add(t),
        this.enteringChildren ?? (this.enteringChildren = new Set()),
        this.enteringChildren.add(t));
    }
    removeChild(t) {
      (this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t));
    }
    bindToMotionValue(t, e) {
      let i;
      if (
        (this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)(),
        e.accelerate && h.M.has(t) && this.current instanceof HTMLElement)
      ) {
        let { factory: i, keyframes: s, times: r, ease: o, duration: a } = e.accelerate,
          h = new l.m({
            element: this.current,
            name: t,
            keyframes: s,
            times: r,
            ease: o,
            duration: (0, n.f)(a),
          }),
          u = i(h);
        this.valueSubscriptions.set(t, () => {
          (u(), h.cancel());
        });
        return;
      }
      let s = S.f.has(t);
      s && this.onBindTransform && this.onBindTransform();
      let r = e.on("change", (e) => {
        ((this.latestValues[t] = e),
          this.props.onUpdate && M.Gt.preRender(this.notifyUpdate),
          s && this.projection && (this.projection.isTransformDirty = !0),
          this.scheduleRender());
      });
      ("undefined" != typeof window &&
        window.MotionCheckAppearSync &&
        (i = window.MotionCheckAppearSync(this, t, e)),
        this.valueSubscriptions.set(t, () => {
          (r(), i && i(), e.owner && e.stop());
        }));
    }
    sortNodePosition(t) {
      return this.current && this.sortInstanceNodePosition && this.type === t.type
        ? this.sortInstanceNodePosition(this.current, t.current)
        : 0;
    }
    updateFeatures() {
      let t = "animation";
      for (t in V) {
        let e = V[t];
        if (!e) continue;
        let { isEnabled: i, Feature: n } = e;
        if (
          (!this.features[t] && n && i(this.props) && (this.features[t] = new n(this)),
          this.features[t])
        ) {
          let e = this.features[t];
          e.isMounted ? e.update() : (e.mount(), (e.isMounted = !0));
        }
      }
    }
    triggerBuild() {
      this.build(this.renderState, this.latestValues, this.props);
    }
    measureViewportBox() {
      return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, c.ge)();
    }
    getStaticValue(t) {
      return this.latestValues[t];
    }
    setStaticValue(t, e) {
      this.latestValues[t] = e;
    }
    update(t, e) {
      ((t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(),
        (this.prevProps = this.props),
        (this.props = t),
        (this.prevPresenceContext = this.presenceContext),
        (this.presenceContext = e));
      for (let e = 0; e < k.length; e++) {
        let i = k[e];
        this.propEventSubscriptions[i] &&
          (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
        let n = t["on" + i];
        n && (this.propEventSubscriptions[i] = this.on(i, n));
      }
      ((this.prevMotionValues = (function (t, e, i) {
        for (let n in e) {
          let s = e[n],
            r = i[n];
          if ((0, w.S)(s)) t.addValue(n, s);
          else if ((0, w.S)(r)) t.addValue(n, (0, p.OQ)(s, { owner: t }));
          else if (r !== s)
            if (t.hasValue(n)) {
              let e = t.getValue(n);
              !0 === e.liveStyle ? e.jump(s) : e.hasAnimated || e.set(s);
            } else {
              let e = t.getStaticValue(n);
              t.addValue(n, (0, p.OQ)(void 0 !== e ? e : s, { owner: t }));
            }
        }
        for (let n in i) void 0 === e[n] && t.removeValue(n);
        return e;
      })(
        this,
        this.scrapeMotionValuesFromProps(t, this.prevProps || {}, this),
        this.prevMotionValues,
      )),
        this.handleChildMotionValue && this.handleChildMotionValue());
    }
    getProps() {
      return this.props;
    }
    getVariant(t) {
      return this.props.variants ? this.props.variants[t] : void 0;
    }
    getDefaultTransition() {
      return this.props.transition;
    }
    getTransformPagePoint() {
      return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
      return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
    }
    addVariantChild(t) {
      let e = this.getClosestVariantNode();
      if (e)
        return (e.variantChildren && e.variantChildren.add(t), () => e.variantChildren.delete(t));
    }
    addValue(t, e) {
      let i = this.values.get(t);
      e !== i &&
        (i && this.removeValue(t),
        this.bindToMotionValue(t, e),
        this.values.set(t, e),
        (this.latestValues[t] = e.get()));
    }
    removeValue(t) {
      this.values.delete(t);
      let e = this.valueSubscriptions.get(t);
      (e && (e(), this.valueSubscriptions.delete(t)),
        delete this.latestValues[t],
        this.removeValueFromRenderState(t, this.renderState));
    }
    hasValue(t) {
      return this.values.has(t);
    }
    getValue(t, e) {
      if (this.props.values && this.props.values[t]) return this.props.values[t];
      let i = this.values.get(t);
      return (
        void 0 === i &&
          void 0 !== e &&
          ((i = (0, p.OQ)(null === e ? void 0 : e, { owner: this })), this.addValue(t, i)),
        i
      );
    }
    readValue(t, e) {
      let i =
        void 0 === this.latestValues[t] && this.current
          ? (this.getBaseTargetFromProps(this.props, t) ??
            this.readValueFromInstance(this.current, t, this.options))
          : this.latestValues[t];
      if (null != i) {
        if ("string" == typeof i && ((0, s.i)(i) || (0, r.$)(i))) i = parseFloat(i);
        else {
          let n;
          ((n = i), !x.find((0, g.w)(n)) && m.f.test(e) && (i = (0, f.J)(t, e)));
        }
        this.setBaseTarget(t, (0, w.S)(i) ? i.get() : i);
      }
      return (0, w.S)(i) ? i.get() : i;
    }
    setBaseTarget(t, e) {
      this.baseTarget[t] = e;
    }
    getBaseTarget(t) {
      let e,
        { initial: i } = this.props;
      if ("string" == typeof i || "object" == typeof i) {
        let n = (0, A.a)(this.props, i, this.presenceContext?.custom);
        n && (e = n[t]);
      }
      if (i && void 0 !== e) return e;
      let n = this.getBaseTargetFromProps(this.props, t);
      return void 0 === n || (0, w.S)(n)
        ? void 0 !== this.initialValues[t] && void 0 === e
          ? void 0
          : this.baseTarget[t]
        : n;
    }
    on(t, e) {
      return (this.events[t] || (this.events[t] = new o.v()), this.events[t].add(e));
    }
    notify(t, ...e) {
      this.events[t] && this.events[t].notify(...e);
    }
    scheduleRenderMicrotask() {
      u.k.render(this.render);
    }
  }
}
